import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const FullLoader = () => (
  <div className="min-h-screen grid place-items-center bg-[#F8FAFC]" data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
  </div>
);

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
